<template>
    <div>
        <CRow v-if="products.length > 0">
            <CCol v-for="(item, index) in products" :key="index" lg="3" sm="4" class="product-card">
                <ProductCard :item="item" />
            </CCol>

            <CCol sm="12" style="display: grid;place-items: center;">
                <CPagination
                    v-if="pagination.last_page > 1 && !pagination.no_paginate"
                    :activePage.sync="pagination.current_page"
                    :pages="pagination.last_page"
                    align="center"
                    size="sm"
                    @update:activePage="filterMe"
                    :limit="6"
                />
            </CCol>
        </CRow>
        <CRow v-else>
            <CCol sm="11">
                <EmptyPage style="margin-right: -11px;" />
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ProductCard } from '../components'

export default {
    name: 'ProductGrid',

    components: {
        ProductCard,
    },

    computed: {
        ...mapGetters({
            pagination: 'product/pagination',
            products: 'product/products',
            filters: 'product/filters',
        }),
    },

    methods: {
        ...mapActions({
            fetchProduct: 'product/fetch',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        filterMe(activePage) {
            this.setShowLoading()
            this.fetchProduct({
                page: activePage,
                ...this.filters,

            }).then(() => {
                this.setShowLoading(false)
            })
            this.pagination.page = activePage
        },
    },
}
</script>
<style scoped>
.product-card {
    margin: 0 -10px -14px;
}
@media only screen and (max-width: 985px) {
    .product-card {
        margin: 0 -10;
    }
}
</style>